import { getService, postService } from '../api/service.js'
// 景区工作台 数量统计

export const GetScenicOrderCount = params =>{ 
  return postService('api/scenic/GetScenicOrderCount', params)
}
// 景区工作台 短信列表
export const GetScenicNewMailList = params =>{ 
  return postService('api/scenic/GetScenicNewMailList', params)
}
// 删除短信
export const deleteSenicNewMail = params =>{ 
  return postService('api/scenic/deleteSenicNewMail', params)
}
// 批量删除短信
export const deleteAllScenicNewMail = params =>{ 
  return postService('api/scenic/deleteAllScenicNewMail', params)
}
// 短信详情
export const getScenicNewMailInfo = params =>{ 
  return postService('api/scenic/getScenicNewMailInfo', params)
}
//  全部已读

export const readAllsenicNewMail = params =>{ 
  return postService('api/scenic/readAllsenicNewMail', params)
}

// 打印详情

export const SencicPrintMss = params =>{ 
  return postService('api/scenicorder/SencicPrintMss', params)
}

// 验票
export const Ticket = params =>{ 
  return postService('api/scenicorder/Ticket', params)
}

// 产品列表
export const GetScenicList = params =>{ 
  return postService('api/product/GetScenicList', params)
}

// 日历统计
export const cldOrderCount = params =>{ 
  return postService('api/scenicorder/cldOrderCount', params)
} 
// 日历导出
export const cldOrderCountExport = params =>{ 
  return postService('api/scenicorder/cldOrderCountExport', params)
} 


// 产品列表排序

export const UpdateSort = params =>{ 
  return postService('api/product/UpdateSort', params)
}
// 上下线
export const SaveUseFlag = params =>{ 
  return postService('api/product/SaveUseFlag', params)
}

// 产品详情
export const getProductInfo = params =>{ 
  return postService('api/product/getProductInfo', params)
}
// 添加产品
export const AddScenicProduct = params =>{ 
  return postService('api/product/AddScenicProduct', params)
}
// 修改产品
export const UpdateScenicProduct = params =>{ 
  return postService('api/product/UpdateScenicProduct', params)
}

//日历票批量设置接口
export const SetBatchProduct = params =>{ 
  return postService('api/product/SetBatchProduct', params)
}

//日历票单独设置接口
export const SetAloneProduct = params =>{ 
  return postService('api/product/SetAloneProduct', params)
}

// 获取担负日历价格

export const CldDateList = params =>{ 
  return postService('api/product/CldDateList', params)
}

// 获取批量日历价格 批量展示页面

export const GetWeek = params =>{ 
  return postService('api/product/GetWeek', params)
}
// 产品分类（不分页，老接口，部分地方复用）
export const ScenicProductType = params =>{ 
  return postService('api/product/ScenicProductType', params)
}
// 产品分类列表（分页）
export const getProductTypeList = params => {
  return postService('api/product/getProductTypeList', params)
}
// 添加产品分类
export const addProductType = params => {
  return postService('api/product/addProductType', params)
}
// 修改产品分类
export const updateProductType = params => {
  return postService('api/product/updateProductType', params)
}
// 产品分类详情
export const getProductTypeInfo = params => {
  return postService('api/product/getProductTypeInfo', params)
}
// 删除产品分类
export const deleteProductType = params => {
  return postService('api/product/deleteProductType', params)
}
// 删除产品

export const DelScenicProduct = params =>{ 
  return postService('api/product/DelScenicProduct', params)
}

// 订单管理 列表
export const getScenicOrderList = params =>{ 
  return postService('api/scenicorder/getScenicOrderList', params)
}

// 订单详情
export const getScenicOrderInfo = params =>{ 
  return postService('api/scenicorder/getScenicOrderInfo', params)
}

// 导出报表
export const ScenicPostExport = params =>{ 
  return getService('api/scenicorder/ScenicPostExport', params)
}
// 重发短信
export const sendSms = params =>{ 
  return postService('api/scenicorder/sendSms', params)
}
// 景区退款
export const ScenicRefund = params =>{ 
  return postService('api/scenic/ScenicRefund', params)
}
// 景区撤销退款
export const RevocationRefund = params =>{ 
  return postService('api/scenic/RevocationRefund', params)
}





//  分销商短信统计       短信统计列表  
export const DisSMSstatistics = params =>{ 
  return postService('api/scenicorder/DisSMSstatistics', params)
}
// 景区分销商短信订单详情   短信统计详情
export const DisOrderDetail = params =>{ 
  return postService('api/scenicorder/DisOrderDetail', params)
}

// 短信充值统计   列表
export const ScenicSMSstatistics = params =>{ 
  return postService('api/scenicorder/ScenicSMSstatistics', params)
}
// SMSstatistics

export const SMSstatistics = params =>{ 
  return postService('api/scenicorder/SMSstatistics', params)
}

// 系统管理

// 景区设置
// 基本信息
export const ScenicMessage = params =>{ 
  return postService('api/scenic/ScenicMessage', params)
}
// 景区信息设置

export const ScenicSetUpParameters = params =>{ 
  return postService('api/scenic/ScenicSetUpParameters', params)
}
// 景区信息修改
export const ScenicUpdateUpParameters = params =>{ 
  return postService('api/scenic/ScenicUpdateUpParameters', params)
}

// 短信设置

export const ScenicNoteSet = params =>{ 
  return postService('api/scenic/ScenicNoteSet', params)
}

// 接口展示

export const ScenicPortList = params =>{ 
  return postService('api/scenic/ScenicPortList', params)
}

// 接口设置 
export const setApiAccount = params =>{ 
  return postService('api/scenic/setApiAccount', params)
}

// 添加应用接口
export const ScenicPortSet = params =>{ 
  return postService('api/scenic/ScenicPortSet', params)
}
//编辑群发短信

export const MasstextingSms = params =>{ 
  return postService('api/scenicorder/MasstextingSMS', params)
}
//编辑群发短信

export const addQfTemplate = params =>{ 
  return postService('api/scenic/addQfTemplate', params)
}
//群发模板详情

export const getQfTemplate = params =>{ 
  return postService('api/scenic/getQfTemplate', params)
}
//群发数量

export const QFSMS = params =>{ 
  return postService('api/scenicorder/QFSMS', params)
}

// 管理员列表

export const ScenicUserAll = params =>{ 
  return postService('api/auth/ScenicUserAll', params)
}
// 管理员详情
export const Userfirst = params =>{ 
  return postService('api/auth/Userfirst', params)
}
// 添加管理员
export const QueryingUserRoles = params =>{ 
  return postService('api/auth/CreateAdministrator', params)
}
// 修改管理员
export const UpdateAdministrator = params =>{ 
  return postService('api/auth/UpdateAdministrator', params)
}
// 删除管理员

export const DeteleAdministrator = params =>{ 
  return postService('api/auth/DeteleAdministrator', params)
}
// 角色列表
export const List = params =>{ 
  return postService('api/auth/List', params)
}
// 添加角色
export const AddRule = params =>{ 
  return postService('api/auth/AddRule', params)
}
// 删除角色

export const DeteleRule = params =>{ 
  return postService('api/auth/DeteleRule', params)
}
// 角色详情修改

export const UpdateRule = params =>{ 
  return postService('api/auth/UpdateRule', params)
}

// 权限列表

export const getRoleNodeList = params =>{ 
  return postService('api/auth/getRoleNodeList', params)
}
// 权限设置

export const SetAuth = params =>{ 
  return postService('api/auth/SetAuth', params)
}

// 合作方展示
// 去哪儿展示
export const supplySetQunar = params =>{ 
  return postService('api/scenic/supplySetQunar', params)
}
// 美团展示
export const supplySetMeituan = params =>{ 
  return postService('api/scenic/supplySetMeituan', params)
}
// 携程展示
export const supplySetXiechen = params =>{ 
  return postService('api/scenic/supplySetXiechen', params)
}
// 美团修改

export const supplySetMeituanSave = params =>{ 
  return postService('api/scenic/supplySetMeituanSave', params)
}
// 美团添加

export const supplySetMeituanAdd = params =>{ 
  return postService('api/scenic/supplySetMeituanAdd', params)
}

// 去哪儿添加

export const supplySetQunarAdd = params =>{ 
  return postService('api/scenic/supplySetQunarAdd', params)
}

// 去哪修改
export const supplySetQunarSave = params =>{ 
  return postService('api/scenic/supplySetQunarSave', params)
}

// 携程添加

export const supplySetXiechenAdd = params =>{ 
  return postService('api/scenic/supplySetXiechenAdd', params)
}
// 携程修改
export const supplySetXiechenSave = params =>{ 
  return postService('api/scenic/supplySetXiechenSave', params)
}


// 供应商展示

export const GetZWY = params =>{ 
  return postService('api/scenic/GetZWY', params)
}

export const NewGetZWY = params =>{ 
  return postService('api/scenic/NewGetZWY', params)
}
// 供应商添加

export const AddConfiguration = params =>{ 
  return postService('api/scenic/AddConfiguration', params)
}
// 供应商修改
export const UpdateConfiguration = params =>{ 
  return postService('api/scenic/UpdateConfiguration', params)
}

// 快手获取配置
export const getKuaiShou = params =>{ 
  return postService('api/scenic/getKuaiShou', params)
}
// 快手添加配置
export const addKuaiShou = params =>{ 
  return postService('api/scenic/addKuaiShou', params)
}
// 快手修改配置
export const updateKuaiShou = params =>{ 
  return postService('api/scenic/updateKuaiShou', params)
}
// 获取抖音配置
export const getDouYin = params =>{ 
  return postService('api/scenic/getDouYin', params)
}
// 抖音修改配置
export const updateDouYin = params =>{ 
  return postService('api/scenic/updateDouYin', params)
}
// 抖音添加配置
export const addDouYin = params =>{ 
  return postService('api/scenic/addDouYin', params)
}

// 抖音删除配置
export const deleteDouYin = params => {
  return postService('api/scenic/deleteDouYin', params)
}

// 景区下获取分销商

export const getScenicListDistrbutor = params =>{ 
  return postService('api/scenic/getScenicListDistrbutor', params)
}
// 分销商统计
export const SeniceStatisticalData = params =>{ 
  return postService('api/scenic/SeniceStatisticalData', params)
}
// 分销商详情

export const ScenicDisDetail = params =>{ 
  return postService('api/scenic/ScenicDisDetail', params)
}

//分销商业务联系信息 

export const DisSetPhone = params =>{ 
  return postService('api/scenic/DisSetPhone', params)
}
// 添加分销商

export const addDistributor = params =>{ 
  return postService('api/scenic/addDistributor', params)
}

// 充值记录

export const ScenicRechargeRecord = params =>{ 
  return postService('api/scenic/ScenicRechargeRecord', params)
}
// 充值
export const rechargeScenic = params =>{ 
  return postService('api/scenic/rechargeScenic', params)
}
// 期票  景区可授权产品

export const LongActingTicketList = params =>{ 
  return postService('api/scenic/LongActingTicketList', params)
}
// 已授权产品
export const GetTermBill = params =>{ 
  return postService('api/scenic/GetTermBill', params)
}
// 景区期票批量授权 确认授权

export const ScenicAuthorizationDis = params =>{ 
  return postService('api/scenic/ScenicAuthorizationDis', params)
}


// 日历票 景区拉取日历价格

export const getScenicProductCld = params =>{ 
  return postService('api/scenic/getScenicProductCld', params)
}

// 景区分销商授权日历列表
export const getDistributorCldList = params =>{ 
  return postService('api/scenic/getDistributorCldList', params)
}

// 迁出功能

export const ScenicDisSave = params =>{ 
  return postService('api/scenic/ScenicDisSave', params)
}

// 景区分销商 日历单独设置

export const aloneCldProduct = params =>{ 
  return postService('api/scenic/aloneCldProduct', params)
}
// 景区分销商 日历批量设置

export const batchCldProduct = params =>{ 
  return postService('api/scenic/CldProduct', params)
}

//景区分销商 授权数量修改 列表

export const ProductAndDistributorList = params =>{ 
  return postService('api/scenic/ProductAndDistributorList', params)
}

// 修改分销商授权的库存限制
export const SetDayAstrict = params =>{ 
  return postService('api/scenic/SetDayAstrict', params)
}


// 发票 列表
export const getScenicCloseList = params =>{ 
  return postService('api/scenicclose/getScenicCloseList', params)
}

// 销售统计 列表 
export const DirectSellingTJ = params =>{ 
  return postService('api/scenic/DirectSellingTJ', params)
}

// 销售统计详情
export const DirectSellingTJXq = params =>{ 
  return postService('api/scenic/DirectSellingTJXq', params)
}

// 消费详情 核销
export const TicketConsumeTJXQ = params =>{ 
  return postService('api/scenic/TicketConsumeTJXQ', params)
}
// 消费导出报表 核销
export const TicketConsumeExport = params =>{ 
  return postService('api/scenic/TicketConsumeExport', params)
}
// 退票统计

export const RefundTJ = params =>{ 
  return postService('api/scenic/RefundTJ', params)
}
// 退票详情
export const RefundTJXQ = params =>{ 
  return postService('api/scenic/RefundTJXQ', params)
}
//退票详情导出 
export const RefundExport = params =>{ 
  return postService('api/scenic/RefundExport', params)
}


// 分销统计、
// 分销退票统计
export const ScenicDisRefundTJ = params =>{ 
  return postService('api/scenic/ScenicDisRefundTJ', params)
}

export const DisProductRefundTotal = params =>{ 
  return postService('api/scenic/DisProductRefundTotal', params)
}

// 退票统计明细、
export const ScenicDisRefundTJXQ = params =>{ 
  return postService('api/scenic/ScenicDisRefundTJXQ', params)
}
export const GetScenicDisSellOneExport = params =>{ 
  return postService('api/scenic/GetScenicDisSellOneExport', params)
}

// 消费统计列表

export const ScenicDisTicketTJ = params =>{ 
  return postService('api/scenic/ScenicDisTicketTJ', params)
}
// 消费统计 产品


// 消费统计明细
export const ScenicDisTicketTJXQ = params =>{ 
  return postService('api/scenic/ScenicDisTicketTJXQ', params)
}

// 销售统计

export const ScenicDisSellTJ = params =>{ 
  return postService('api/scenic/ScenicDisSellTJ', params)
}
// 销售统计详情

export const ScenicDisSellOneTJ = params =>{ 
  return postService('api/scenic/ScenicDisSellOneTJ', params)
}
// 退票导出

export const RefundTJXQExport = params =>{ 
  return postService('api/scenic/RefundTJXQExport', params)
}
//消费导出

export const ScenicDisTicketTJExport = params =>{ 
  return postService('api/scenic/ScenicDisTicketTJExport', params)
}

export const DisProductVerifiExport = params =>{ 
  return postService('api/scenic/DisProductVerifiExport', params)
}
//消费详情导出

export const ScenicDisTicketTJXQExport = params =>{ 
  return postService('api/scenic/ScenicDisTicketTJXQExport', params)
}


// 短信充值展示页面

export const GetSMStopup = params =>{ 
  return postService('api/scenicorder/GetSMStopup', params)
}
// 短信充值

export const SetSMStopup = params =>{ 
  return postService('api/scenicorder/SetSMStopup', params)
}

// 拉起支付

export const PaySMS = params =>{ 
  return postService('api/scenicorder/PaySMS', params)
}

// 黑名单列表
export const getBlackList = params =>{ 
  return postService('api/scenic/getBlackList', params)
}

// 黑名单删除
export const deleteBlackList = params =>{ 
  return postService('api/scenic/deleteBlackList', params)
}
// 黑名单导出

export const exportBlackList = params =>{ 
  return postService('api/scenic/exportBlackList', params)
}
// 黑名单添加

export const addBlackList = params =>{ 
  return postService('api/scenic/addBlackList', params)
}
// 获取汇款方信息
export const getPayInfo = params =>{ 
  return postService('api/scenic/getPayInfo', params)
}
// 汇款支付

export const remitApi = params =>{ 
  return postService('api/scenic/remitApi', params)
}



// 直销统计 销售自然日统计
export const SalesStatistics = params =>{ 
  return postService('api/scenic/SalesStatistics', params)
}

// 销售产品统计

export const ProductIDSalesStatistics = params =>{ 
  return postService('api/scenic/ProductIDSalesStatistics', params)
}
// 销售订单数量与金额统计
export const TotalSales = params =>{ 
  return postService('api/scenic/TotalSales', params)
}


// 核销订单金额统计

export const GeneralLedger = params =>{ 
  return postService('api/scenic/GeneralLedger', params)
}

// 核销自然日统计
export const TicketConsumeTJ = params =>{ 
  return postService('api/scenic/TicketConsumeTJ', params)
}
// 核销产品统计
export const ProductTicketConsumeTJ = params =>{ 
  return postService('api/scenic/ProductTicketConsumeTJ', params)
}


// 退款数量与金额统计
export const RefundGeneralLedger = params =>{ 
  return postService('api/scenic/RefundGeneralLedger', params)
}



// 销售自然日导出
export const exportSalesStatistics = params =>{ 
  return postService('api/scenic/exportSalesStatistics', params)
}
// 销售统计（产品）统计导出
export const ProductIDSalesStatisticsExport = params =>{ 
  return postService('api/scenic/ProductIDSalesStatisticsExport', params)
}

// 核销自然日统计导出
export const TicketConsumeTJExport = params =>{ 
  return postService('api/scenic/TicketConsumeTJExport', params)
}
// 核销（产品）统计导出
export const ProductTicketConsumeTJExport = params =>{ 
  return postService('api/scenic/ProductTicketConsumeTJExport', params)
}
// 退款自然日统计导出
export const RefundDateExport = params =>{ 
  return postService('api/scenic/RefundDateExport', params)
}
// 退款自然日统计导出
export const ProductRefundExport = params =>{ 
  return postService('api/scenic/ProductRefundExport', params)
}
// 退票产品列表
export const ProductRefundTotal = params =>{ 
  return postService('api/scenic/ProductRefundTotal', params)
}
// 销售订单数量与数量统计
export const DistributorIDTotalSales = params =>{ 
  return postService('api/scenic/DistributorIDTotalSales', params)
}
// 退款金额数量统计
export const DistributorRefundGeneralLedger = params =>{ 
  return postService('api/scenic/DistributorRefundGeneralLedger', params)
}
// 消费金额数量统计
export const DistributorIDVerifiGeneralLedger = params =>{ 
  return postService('api/scenic/DistributorIDVerifiGeneralLedger', params)
}
// 消费产品统计

export const DisProductVerifiTotal = params =>{ 
  return postService('api/scenic/DisProductVerifiTotal', params)
}

// 导出

export const exportDistributorSalesStatistics = params =>{ 
  return postService('api/scenic/exportDistributorSalesStatistics', params)
}
export const ScenicDisSellOneExport = params =>{ 
  return postService('api/scenic/ScenicDisSellOneExport', params)
}

export const DistributorIDRefundDateExport = params =>{ 
  return postService('api/scenic/DistributorIDRefundDateExport', params)
}

export const DisProductRefundExport = params =>{ 
  return postService('api/scenic/DisProductRefundExport', params)
}
export const VerificationSheetExport = params =>{ 
  return postService('api/scenicorder/VerificationSheetExport', params)
}
export const VerificationSheetDetailExport = params =>{ 
  return postService('api/scenicorder/VerificationSheetDetailExport', params)
}
export const GetScenicNote = params =>{ 
  return postService('api/scenic/GetScenicNote', params)
}
export const NewScenicAuthorizationDis = params =>{ 
  return postService('api/scenic/NewScenicAuthorizationDis', params)
}
export const ScenicCancelDisImpower = params =>{ 
  return postService('api/scenic/ScenicCancelDisImpower', params)
}
export const DirectSellingTJXqExport = params =>{ 
  return postService('api/scenic/DirectSellingTJXqExport', params)
}
// 微商城列表
export const WshopList = params =>{ 
  return postService('api/product/WshopList', params)
}
// 微商城删除
export const WshopDetele = params =>{ 
  return postService('api/product/WshopDetele', params)
}
// 微商城确认授权
export const ImpowerProduct = params =>{ 
  return postService('api/product/ImpowerProduct', params)
}
// 餐厅列表
export const RestaurantList = params =>{ 
  return postService('api/restaurant/RestaurantList', params)
}
// 餐厅添加

export const RestaurantAdd = params =>{ 
  return postService('api/restaurant/RestaurantAdd', params)
}
// 餐厅修改

export const RestaurantUpdate = params =>{ 
  return postService('api/restaurant/RestaurantUpdate', params)
}
// 档口列表

export const StallList = params =>{ 
  return postService('api/restaurant/StallList', params)
}
//  分类列表
export const ClassList = params =>{ 
  return postService('api/restaurant/ClassList', params)
}
// 菜品列表

export const MenuList = params =>{ 
  return postService('api/restaurant/MenuList', params)
}
// 菜品详情
export const Menudetail = params =>{ 
  return postService('api/restaurant/Menudetail', params)
}
// 添加分类

export const ClassAdd = params =>{ 
  return postService('api/restaurant/ClassAdd', params)
}
// 修改分类

export const ClassUpdate = params =>{ 
  return postService('api/restaurant/ClassUpdate', params)
}
// 档口添加

export const StallAdd = params =>{ 
  return postService('api/restaurant/StallAdd', params)
}
// 档口删除

export const StallDelete = params =>{ 
  return postService('api/restaurant/StallDelete', params)
}

// 菜品添加
export const MenuAdd = params =>{ 
  return postService('api/restaurant/MenuAdd', params)
}
// 菜品修改
export const MenuUpdate = params =>{ 
  return postService('api/restaurant/MenuUpdate', params)
}
// 小程序配置信息
export const SysFirst = params =>{ 
  return postService('api/restaurant/SysFirst', params)
}
// 小程序配置添加

export const SysAdd = params =>{ 
  return postService('api/restaurant/SysAdd', params)
}
// 小程序配置修改

export const SysUpdate = params =>{ 
  return postService('api/restaurant/SysUpdate', params)
}
// 桌位列表
export const WftableList = params =>{ 
  return postService('api/restaurant/WftableList', params)
}
// 添加桌位

export const WftableAdd = params =>{ 
  return postService('api/restaurant/WftableAdd', params)
}
// 二维码
export const WftableGetCode = params =>{ 
  return postService('api/restaurant/WftableGetCode', params)
}
// 桌位修改
export const WftableUpdate = params =>{ 
  return postService('api/restaurant/WftableUpdate', params)
}
// 订单信息

export const WforderList = params =>{ 
  return postService('api/restaurant/WforderList', params)
}
// 订单导出

export const WforderExport = params =>{ 
  return postService('api/restaurant/WforderExport', params)
}
//订单退款

export const WforderRefund = params =>{ 
  return postService('api/restaurant/WforderRefund', params)
}
// 已授权列表
export const MenuGranted = params =>{ 
  return postService('api/restaurant/MenuGranted', params)
}
// 确认授权

export const MenuSQ = params =>{ 
  return postService('api/restaurant/MenuSQ', params)
}
export const StallUpdate = params =>{ 
  return postService('api/restaurant/StallUpdate', params)
}
export const WfcodeList = params =>{ 
  return postService('api/restaurant/WfcodeList', params)
}
export const getSmsTemplate = params =>{ 
  return postService('api/scenic/getSmsTemplate', params)
}
export const setSmsTemplate = params =>{ 
  return postService('api/scenic/setSmsTemplate', params)
}

export const GetOuterNetAnalysis = params =>{ 
  return postService('api/scenic/GetOuterNetAnalysis', params)
}
export const OuterNetAnalysisAdd = params =>{ 
  return postService('api/scenic/OuterNetAnalysisAdd', params)
}
export const SetOuterNetAnalysis = params =>{ 
  return postService('api/scenic/SetOuterNetAnalysis', params)
}
export const DelOuterNetAnalysis = params =>{ 
  return postService('api/scenic/DelOuterNetAnalysis', params)
}

export const changeSort = params =>{ 
  return postService('api/scenic/changeSort', params)
}
export const getScenicOrderListNew = params =>{ 
  return postService('api/scenic/getScenicOrderListNew', params)
}
// 客服查询
export const getServiceList = params =>{ 
  return postService('api/scenic/getServiceList', params)
}
// 
// 弹出站内信
export const getSuperAdminNotice = params =>{ 
  return postService('api/scenic/getSuperAdminNotice', params)
}
// 景区阅读信息

export const readStateChange = params =>{ 
  return postService('api/scenic/readStateChange', params)
}

// 产品批量删除
export const deleteAllProduct = params =>{ 
  return postService('api/scenic/deleteAllProduct', params)
}
// 复制产品
export const copyPro = params =>{ 
  return postService('api/scenic/copyPro', params)
}

// 回收站列表

export const deleteProductList = params =>{ 
  return postService('api/scenic/deleteProductList', params)
}
// 恢复商品

export const recoverAllProduct = params =>{ 
  return postService('api/scenic/recoverAllProduct', params)
}


// 强制核销
export const coerceTicket = params =>{ 
  return postService('api/scenicorder/coerceTicket', params)
}
// 撤销核销
export const fulfilmentCancel = params =>{ 
  return postService('api/scenicorder/fulfilmentCancel', params)
}
// 同步第三方订单
export const pushConsumeNotice = params =>{ 
  return postService('api/scenicorder/pushConsumeNotice', params)
}
// 导出手机号
export const exportMobile = params =>{ 
  return postService('api/scenic/exportMobile', params)
}
// 抖音核销列表
export const douyinCodeVerifyRecordList = params =>{ 
  return postService('api/scenic/douyinCodeVerifyRecordList', params)
}
// 抖音核销列表导出
export const exportDouyinCodeVerifyRecord = params =>{ 
  return postService('api/scenic/exportDouyinCodeVerifyRecord', params)
}
// 退款短信统计明细
export const refundSmsOrderList = params =>{ 
  return postService('api/scenicorder/refundSmsOrderList', params)
}
// 退款短信统计明细导出
export const exportRefundSmsOrder = params =>{ 
  return postService('api/scenicorder/exportRefundSmsOrder', params)
}
// 订单大屏
export const orderscreen = params =>{ 
  return postService('api/restaurant/orderscreen', params)
}
// 套票子产品类型
export const ScenicProductSonType = params =>{ 
  return postService('api/product/ScenicProductSonType', params)
}

// 分类列表
export const getMovieTypeList = params =>{ 
  return postService('api/Movie/getMovieTypeList', params)
}
// 添加分类
export const addMovieType = params =>{ 
  return postService('api/Movie/addMovieType', params)
}
//修改分类
export const updateMovieType = params =>{ 
  return postService('api/Movie/updateMovieType', params)
}
// 分类详情
export const getMovieTypeInfo = params =>{ 
  return postService('api/Movie/getMovieTypeInfo', params)
}
// 分类删除
export const deleteMovieType = params =>{ 
  return postService('api/Movie/deleteMovieType', params)
}
// 分类排序
export const sortMovieType = params =>{ 
  return postService('api/Movie/sortMovieType', params)
}
// 订单列表
export const getMovieOrderList = params =>{ 
  return postService('api/Movie/getMovieOrderList', params)
}
// 订单详情
export const getMovieOrderInfo = params =>{ 
  return postService('api/Movie/getMovieOrderInfo', params)
}
// 区域列表
export const getMovieAreaList = params =>{ 
  return postService('api/Movie/getMovieAreaList', params)
}
// 区域状态修改
export const updateStatusMovieArea = params =>{ 
  return postService('api/Movie/updateStatusMovieArea', params)
}
// 区域删除
export const deleteMovieArea = params =>{ 
  return postService('api/Movie/deleteMovieArea', params)
}
// 区域添加
export const addMovieArea = params =>{ 
  return postService('api/Movie/addMovieArea', params)
}
// 区域修改
export const updateMovieArea = params =>{ 
  return postService('api/Movie/updateMovieArea', params)
}
// 区域详情
export const getMovieAreaInfo = params =>{ 
  return postService('api/Movie/getMovieAreaInfo', params)
}
// 演出列表
export const getMovieList = params =>{ 
  return postService('api/Movie/getMovieList', params)
}
// 演出排序
export const movieSort = params =>{ 
  return postService('api/Movie/movieSort', params)
}
//添加演出
export const addMovie = params =>{ 
  return postService('api/Movie/addMovie', params)
}
// 演出详情
export const getMovieInfo = params =>{ 
  return postService('api/Movie/getMovieInfo', params)
}
// 演出删除
export const deleteMovie = params =>{ 
  return postService('api/Movie/deleteMovie', params)
}
// 演出日期
export const getmMvieShowtimes = params =>{ 
  return postService('api/Movie/getmMvieShowtimes', params)
}

// 演出日期设置
export const setMoiveDate = params =>{ 
  return postService('api/Movie/setMoiveDate', params)
}
// 修改演出
export const updateMovie = params =>{ 
  return postService('api/Movie/updateMovie', params)
}
// 获取场次日历

export const getMovieAloneShowtimes = params =>{ 
  return postService('api/Movie/getMovieAloneShowtimes', params)
}
// 日期设置详情
export const setMoiveDateInfo = params =>{ 
  return postService('api/Movie/setMoiveDateInfo', params)
}

// 获取套票子产品信息
export const getProductSonList = params =>{ 
  return postService('api/product/getProductSonList', params)
}
// 添加套票子产品
export const addProductSon = params =>{ 
  return postService('api/product/addProductSon', params)
}

// 订单导出
export const exportMovieOrderList = params =>{ 
  return postService('api/Movie/exportMovieOrderList', params)
}
// 批量订单详细列表
export const getScenicBatchOrderList = params =>{ 
  return postService('api/scenicorder/getScenicBatchOrderList', params)
}
// 批量订单结果数据
export const getBatchResultData = params =>{ 
  return postService('api/scenicorder/getBatchResultData', params)
}
// 添加短信协议信息
export const msgAgreement = params =>{ 
  return postService('api/scenic/msgAgreement', params)
}
// 获取短信协议信息
export const getMsgAgreement = params =>{ 
  return postService('api/scenic/getMsgAgreement', params)
}
// 绿云渠道商
export const GetChannel = params =>{ 
  return postService('api/scenicorder/GetChannel', params)
}
// 景区充值结账时间设置
export const rechargeTimeLimit = params =>{ 
  return postService('api/scenic/rechargeTimeLimit', params)
}

// 核销统计 根据分销商产品统计
export const distributorProductTJ = params =>{ 
  return postService('api/scenic/distributorProductTJ', params)
}
// 核销统计 根据渠道商产品统计
export const channelCodeProductTJ = params =>{ 
  return postService('api/scenic/channelCodeProductTJ', params)
}
export const xcxAppealOrderList = params =>{ 
  return postService('api/scenic/xcxAppealOrderList', params)
}
export const distributorProductTJData = params =>{ 
  return postService('api/scenic/distributorProductTJData', params)
}
export const channelCodeProductTJData = params =>{ 
  return postService('api/scenic/channelCodeProductTJData', params)
}
export const distributorProductTJExport = params =>{ 
  return postService('api/scenic/distributorProductTJExport', params)
}

export const channelCodeProductTJExport = params =>{ 
  return postService('api/scenic/channelCodeProductTJExport', params)
}
export const xcxOrderList = params =>{ 
  return postService('api/scenic/xcxOrderList', params)
}
export const getXcxOrderList = params =>{ 
  return postService('api/scenic/getXcxOrderList', params)
}
export const xcxOrderDetail = params =>{ 
  return postService('api/scenic/xcxOrderDetail', params)
}
export const xcxRefund = params =>{ 
  return postService('api/scenic/xcxRefund', params)
}

export const LyScenicList = params =>{ 
  return postService('api/scenic/LyScenicList', params)
}

export const LyScenicAdd = params =>{ 
  return postService('api/scenic/LyScenicAdd', params)
}
export const LyScenicSave = params =>{ 
  return postService('api/scenic/LyScenicSave', params)
}
export const xcxAppealOrderDetail = params =>{ 
  return postService('api/scenic/xcxAppealOrderDetail', params)
}

export const xcxAppealState = params =>{ 
  return postService('api/scenic/xcxAppealState', params)
}
export const xcxAppealOrderListExport = params =>{ 
  return postService('api/scenic/xcxAppealOrderListExport', params)
}

export const xcxOrderListExport = params =>{ 
  return postService('api/scenic/xcxOrderListExport', params)
}

export const xcxOrderDetailExport = params =>{ 
  return postService('api/scenic/xcxOrderDetailExport', params)
}

export const xcxAppealOrderDetailExport = params =>{ 
  return postService('api/scenic/xcxAppealOrderDetailExport', params)
}


export const ScenicForceRefund = params =>{ 
  return postService('api/scenic/ScenicForceRefund', params)
}
export const orderBackCancelList = params =>{ 
  return postService('api/scenic/orderBackCancelList', params)
}
export const sendNotice = params =>{ 
  return postService('api/officialWeb/sendNotice', params)
}
export const noticeList = params =>{ 
  return postService('api/officialWeb/noticeList', params)
}
export const deleteNoticeInfo = params =>{ 
  return postService('api/officialWeb/deleteNoticeInfo', params)
}
export const getMessageList = params =>{ 
  return postService('api/officialWeb/getMessageList', params)
}
export const messageDetail = params =>{ 
  return postService('api/officialWeb/messageDetail', params)
}


export const lostInfoList = params =>{ 
  return postService('api/officialWeb/lostInfoList', params)
}
export const addLostInfo = params =>{ 
  return postService('api/officialWeb/addLostInfo', params)
}
export const addLostUserInfo = params =>{ 
  return postService('api/officialWeb/addLostUserInfo', params)
}
export const getProductList = params =>{ 
  return postService('api/officialWeb/getProductList', params)
}
export const getProductType = params =>{ 
  return postService('api/officialWeb/getProductType', params)
}
export const addProducts = params =>{ 
  return postService('api/officialWeb/addProduct', params)
}
export const productDetail = params =>{ 
  return postService('api/officialWeb/productDetail', params)
}

export const deleteProduct = params =>{ 
  return postService('api/officialWeb/deleteProduct', params)
}

export const updateSort = params =>{ 
  return postService('api/officialWeb/updateSort', params)
}

export const getItemOrderList = params =>{ 
  return postService('api/officialWeb/getItemOrderList', params)
}
export const addExpressInfo = params =>{ 
  return postService('api/officialWeb/addExpressInfo', params)
}

export const afterSaleDetail = params =>{ 
  return postService('api/officialWeb/afterSaleDetail', params)
}
export const afterSaleRefund = params =>{ 
  return postService('api/officialWeb/afterSaleRefund', params)
}

export const addScenicPayInfo = params =>{ 
  return postService('api/scenic/addScenicPayInfo', params)
}

export const scenicPayInfo = params =>{ 
  return postService('api/scenic/scenicPayInfo', params)
}

export const peopleFlowByDate = params =>{ 
  return postService('api/hctourism/peopleFlowByDate', params)
}